export default __webpack_public_path__ + "static/media/resetpassword-check-icon.d0ede4e7.svg";